function addHover(el, parentEl, typeofElement) {
    jQuery(el).each((i, item) => {
        jQuery(item).hover(function () {
            if (typeofElement === 'div') {
                jQuery(item).addClass('hover');
            } else {
                let a = jQuery(this).closest(parentEl).find(typeofElement);
                if (a && a.length) {
                    a.addClass('hover');
                }
            }
        }, function () {
            if (typeofElement === 'div') {
                jQuery(item).removeClass('hover');
            } else {
                let a = jQuery(this).closest(parentEl).find(typeofElement);
                if (a && a.length) {
                    a.removeClass('hover');
                }
            }
        });
    });

}

function animationOnScroll(element, elementParent, pos = 'center') {
    const animationShowClass = 'animate',
        animationHideClass = 'no-animate';

    jQuery(element).each((i, el) => {
        const parent = jQuery(el).closest(elementParent);
        if (parent && parent.length > 0) {
            let objectTop = parent.position().top + parent.outerHeight() / 3;
            let objectCenter = parent.position().top + (parent.outerHeight() / 2);
            let windowBot = jQuery(window).scrollTop() + jQuery(window).height();
            if (pos === 'top') {
                objectCenter = parent.position().top;
            }

            if (windowBot >= objectCenter) {
                jQuery(el).addClass(animationShowClass).removeClass(animationHideClass);
            } else if (windowBot < objectTop) {
                jQuery(el).removeClass(animationShowClass).addClass(animationHideClass);
            }
        }
    });

}

function headerEffect() {
    const offsetScroll = Window.scrollY || document.documentElement.scrollTop,
        body = jQuery('body');
    console.log(offsetScroll)
    if (offsetScroll > 0) {
        body.addClass('header-fixed')
        jQuery('#shopify-section-aside-bar-section').fadeOut(200);
    } else {
        body.removeClass('header-fixed');
        jQuery('#shopify-section-aside-bar-section').fadeIn(200)
    }
}

// headerEffect();
jQuery(document).ready(function (jQuery) {
    jQuery('body').addClass('loaded');
    animationOnScroll('.animate__block', '.js-section', 'top');
    animationOnScroll('.animate__block--fadein', '.shopify-section', 'top');
    animationOnScroll('.animate__block', '.js-slider-front', 'top');
    addHover('.double__section-left', 'double__section.row', 'div');
    addHover('.double__section-right', 'double__section.row', 'div');
    jQuery(window).on('scroll', (ev) => {
        // headerEffect();
        animationOnScroll('.animate__block', '.js-section', 'top');
        animationOnScroll('.animate__block--fadein', '.shopify-section', 'top');
        animationOnScroll('.animate__block', '.js-slider-front', 'top');
    });
    jQuery('.js-scroll-top').click(function (ev) {
        ev.preventDefault();
        jQuery('body, html').animate({scrollTop: 0 + 'px'}, 1200);
    });
  

 
});

